import { Close } from "@/components/Icon"
import React from "react"
import Flex from "@/components/Flex"
import Box from "@/components/Box"
import Typography from "@/components/Typography"
import Button from "@/components/Button"

type FilterResultProps = {
  teamsFilter: string[]
  setTeamsFilter: (teams: string[]) => void
  locFilter: string[]
  setLocFilter: (loc: string[]) => void
}

export const FilterResult = ({
  teamsFilter,
  setTeamsFilter,
  locFilter,
  setLocFilter,
}: FilterResultProps) => {
  const handleRemoveFilter = (value: string, type: string) => {
    let newFilterArray = []
    if (type === "team") {
      newFilterArray = teamsFilter.filter(x => x !== value)
      setTeamsFilter(newFilterArray)
    } else {
      newFilterArray = locFilter.filter(x => x !== value)
      setLocFilter(newFilterArray)
    }
  }

  return (
    <Flex flexWrap={"wrap"} py={"12px"} mx={"-4px"} justifyContent="flex-start">
      {teamsFilter.map(team => {
        return (
          <Box
            display="flex"
            alignItems="center"
            key={team}
            border={"2px solid #0058AA"}
            borderRadius={"32px"}
            height={"36px"}
            paddingX={2}
            paddingY={1}
            mx={"4px"}
            mb={"12px"}
          >
            <Typography
              mr={"11px"}
              variant="p"
              leadingTrim
              fontSize={"14px"}
              letterSpacing={"0.01em"}
              lineHeight={"145%"}
              color="#001B3C"
            >
              {team}
            </Typography>
            <Button
              variant="plain"
              color="#001B3C"
              onClick={() => handleRemoveFilter(team, "team")}
            >
              <Close fontSize="9px" />
            </Button>
          </Box>
        )
      })}
      {locFilter.map(loc => {
        return (
          <Box
            display="flex"
            alignItems="center"
            key={loc}
            border={"2px solid #0058AA"}
            borderRadius={"32px"}
            height={"36px"}
            paddingX={2}
            paddingY={1}
            mx={"4px"}
            mb={"12px"}
          >
            <Typography
              mr={"11px"}
              variant="p"
              leadingTrim
              fontSize={"14px"}
              letterSpacing={"0.01em"}
              lineHeight={"145%"}
              color="#001B3C"
            >
              {loc}
            </Typography>
            <Button
              variant="plain"
              color="#001B3C"
              onClick={() => handleRemoveFilter(loc, "location")}
            >
              <Close fontSize="9px" />
            </Button>
          </Box>
        )
      })}
    </Flex>
  )
}
